/*
 *  -----------------------------------------------------------------------
 *    <copyright file="admin-report-template.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React from 'react';
import AdminReportTemplateGrid from '@components/admin/admin-report-template-grid';
import PageTitle from '@components/core/page-title/page-title';
import { useTranslation } from 'hooks';

const AdminReportTemplate = () => {
    const { t } = useTranslation();

    return (
        <>
            <PageTitle text={t('admin:manageReportTemplates')} className="mb-10" />
            <AdminReportTemplateGrid />
        </>
    );
};

export default AdminReportTemplate;
